import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-language-icon/jb-language-icon.css.ts
var jb_language_icon_css_default = i`path{fill:var(--stroke-color, #141e55)}@media(forced-colors: active){path{fill:CanvasText}}`;

export {
  jb_language_icon_css_default
};
